import '../../js-lib/swipeshow';
import '../common/tooltip';
import { SendMessageModal }  from '../modal/index';
import RegistryCore from '../common/theknot/registry_core';

import React, { Component } from 'react';
import * as utils from "./utils";
import { getAvatars } from "./avatars/actions";
import { hydratePhotoPosts } from "./photos/actions";

import store from "./store";

import ActivityFeed                from "./activity-feed/components";
import EventSettings               from "./event-settings/components";
import EventViewTabs               from "./event-view-tabs/components";
import Donate                      from "./donate/components";
import Gifts                       from "./gifts/components";
import GuestList                   from "./guestlist/components";
import Polls                       from "./polls/components/index";
import PhotoGallery                from "./photos/components";
import RsvpTab                     from "./rsvp/components/rsvp-tab";
import RsvpResponseBar             from "./rsvp/components/rsvp-response-bar";
import ConnectedSlideshow          from "./slideshow/components/index";
import WhatToBring                 from "./what-to-bring/components";
import { Provider }                from 'react-redux'
import { Router, Route, IndexRedirect, browserHistory } from 'react-router'
import { render }                  from 'react-dom';
import './app-router';

let appRendered = false;
let pageViewCount = 0;

function EventView(props) {
  return (
    <div className="event-view">
        <RsvpResponseBar
          onRsvpTab={props.router.getCurrentLocation().pathname.includes("rsvp")}
        />
      <EventViewTabs />
      {props.children}
      <ConnectedSlideshow />
    </div>
  )
}

function renderEventViewApp() {
  if(renderEventViewApp.called){
    return;
  }


  renderEventViewApp.called = true;

  const rootPath = window.is_preview && !window.is_premium ? "/event/:eventId/preview" : "/event/:eventId";
  // React render
  // Here is where react attaches to the dom.
  // We are also wrapping the app in a <Provider> for the Redux store and we are
  // using ReactRouter to manage the routing:
  // https://github.com/reactjs/react-router
  const app = render(
    <Provider store={store}>
      <Router history={browserHistory}>
        <Route path={rootPath} component={EventView}>
          <IndexRedirect to={!utils.hasRsvpd() && !utils.eventHasPassed() ? "rsvp" : "activity"} />
          <Route path="activity" component={ActivityFeed} onEnter={onRouteEntered} />
          <Route path="donate" component={Donate} onEnter={onRouteEntered} />
          <Route path="gifts" component={Gifts} onEnter={onRouteEntered} />
          <Route path="guestlist" component={GuestList} onEnter={onRouteEntered} />
          <Route path="photos" component={PhotoGallery} onEnter={onRouteEntered} />
          <Route path="polls" component={Polls} onEnter={onRouteEntered} />
          <Route path="settings" component={EventSettings} onEnter={onRouteEntered} />
          <Route path="rsvp" component={RsvpTab} onEnter={onRouteEntered} />
          <Route path="what-to-bring" component={WhatToBring} onEnter={onRouteEntered} />
        </Route>
      </Router>
    </Provider>,
    document.getElementById('event-view-root'),
    function () {
      appDidMount();
    }
  );

  window.app = window.app || {};
  Object.assign(window.app, app);
}

window.renderEventViewApp = renderEventViewApp;

function appDidMount() {
  appRendered = true;

  // Functions that run after the app mounted on the dom
  if (window.evite_event.id) {
    if(!utils.isMobile()) {
      getAvatars();
    }
  }
}

if (document.getElementById('event-view-root') && (!window.is_premium || window.is_mobile_site && !window.is_card)) {
  renderEventViewApp();
}

function onRouteEntered() {
  if (this.path === "photos" && !store.getState().photos.hydrated) {
    hydratePhotoPosts();
  }
  !window.app.router.preventScroll && scrollPage();
  window.app.router.preventScroll = false;

  trackTabRender();

  if(appRendered && pageViewCount > 0) { // not on the first
    evite.when('dfp').then(function() {
      // Adblock removes window.debouncedRefreshAds
      window.debouncedRefreshAds && window.debouncedRefreshAds();
    });
  }

  pageViewCount += 1;
}

function scrollPage() {
  if (document.location.hash) {
    window.setTimeout(function() {
      if (document.getElementById(document.location.hash.substring(1))) {
        return scrollPageToHash();
      }
    }, 500);
  } else {
    return scrollPageToFeedTop();
  }
}

function scrollPageToHash() {
  $('html, body').animate({
    scrollTop: $(document.location.hash).offset().top - 20
  }, 200, "swing");
}

function scrollPageToFeedTop() {
  const top  = window.pageYOffset || document.documentElement.scrollTop;
  const invite_height = $('#design-template-wrapper').outerHeight();
  const threshold = utils.isMobile() ? 0 : (window.is_premium ? invite_height - 50 : invite_height);
  if (top > threshold) {
    $('html, body').animate({scrollTop: threshold}, 200, 'swing');
  }
}

function trackTabRender() {
  if (!appRendered) {
    return false;
  }
  window.setTimeout(function() {
    // DataOps use this to track pageviews within the app
    window.dataLayer.push({
      'event': 'event_view_tab_rendered',
      'destination_url': window.location.pathname
    });
  }, 500);
}

evite.when('document.ready', 'page.render').then(function(){
  RegistryCore.setup();
  evite.resolve('app.init');
});



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/app.es6